// @ts-strict-ignore
import {Component, Input, OnInit} from "@angular/core";
import {
	CameraLayoutOptionsContainer,
	LiveStreamCameraLayoutOptions,
	PlaybackCameraLayoutOptions,
} from "../../../../types/camera-layout-options";
import {BaseRecorderLayout} from "../base-recorder-layout";

@Component({
	selector: "sim-recorder-layout-twobthree",
	templateUrl: "./recorder-layout-twobthree.component.html",
	styleUrls: ["./recorder-layout-twobthree.component.scss"],
	standalone: false,
})
export class RecorderLayoutTwobthreeComponent extends BaseRecorderLayout implements OnInit {
	@Input() cameraLayoutOptionsContainer: CameraLayoutOptionsContainer;

	constructor() {
		super();
	}

	ngOnInit() {}
}
